/****************************************************
 * Module Name:  addLotIntimation.js
 * Project:      Pansuriya Impex Sales & Manufacturing
 * Owner:        info@pansuriyaimpex.com
 *
 * Copyright (c) Pansuriya Impex
 * All rights reserved.
 ****************************************************/
import React, { Component } from "react";
import Modal from "react-bootstrap/Modal";
import CircularProgress from "@mui/material/CircularProgress";
import Constants from "../../../utility/constants";
import Select from "react-select";
import RefreshOutlinedIcon from "@mui/icons-material/RefreshOutlined";
import "bootstrap/dist/css/bootstrap.min.css";
import { Box, Button, TextField, Tooltip, Typography } from "@mui/material";
import Utility from "../../../utility/utility";
import CommonSnackbar from "../../common/commonSnackBar";
import { LoadingButton } from "@mui/lab";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import LotIntimationProxy from "../../../utility/proxy/manager/manufacturingProxy/lotIntimationProxy";
import logo from '../../../images/pansuriya.jpg'
import dayjs from "dayjs";
import SaveIcon from '@mui/icons-material/Save';
import TenderCompanyProxy from "../../../utility/proxy/manager/manufacturingProxy/tenderCompanyProxy";

export default class AddLotIntimationModal extends Component {
  constructor(props) {
    super(props);

    this.state = {
      newExpectedReceive: this.props.editOperation
        ? this.props.sourceData.expectedreceive
        : new Date(),
      newCarat: this.props.editOperation || this.props.sourceData.carats ? this.props.sourceData.carats : "",
      newSize: this.props.editOperation || this.props.sourceData.size ? this.props.sourceData.size : "",
      newPcs: this.props.editOperation || this.props.sourceData.pcs ? this.props.sourceData.pcs : "",
      tenderLotIds: this.props.sourceData.tenderlotids ? this.props.sourceData.tenderlotids : [],
      editable: this.props.sourceData.tenderlotids ? false : true,    // if we get tenderlots that means the intimation is being created from final bid summary (Tender) so we will keep the feilds uneditable
      newCompany: this.props.editOperation || this.props.sourceData.companyid
        ? {
          value: this.props.sourceData.companyid,
          label: this.props.sourceData.companyname,
        }
        : "",
      newReceived: this.props.editOperation
        ? this.props.sourceData.received
        : false,
      showError: false,
      companyOptions: [],
      showCompanyLoadSpinner: true,

      validateLotIntimationPresentSpinner: false,
      showValidationMessage: false,
      lotIntimationAvailable: true,

      caratValidationError: "",
    };
    this.getCompanyData();
  }

  getCompanyData = () => {
    TenderCompanyProxy.GetCompanyMini((response) => {
      this.setCompanyOptions(response);
    });
  };

  setCompanyOptions = (response) => {
    let optionsArray = [];
    response.map((data) => {
      let option = { value: data.id, label: data.id + " | " + data.name };
      optionsArray.push(option);
      return true;
    });
    const selectedCompany = optionsArray.find(
      (option) => option.value === this.props.sourceData.companyid
    );
    this.setState({
      companyOptions: optionsArray,
      showCompanyLoadSpinner: false,
      newCompany: selectedCompany || optionsArray[0],
    });
  }

  handleSave = () => {
    let data = {
      id: this.props.editOperation ? this.props.sourceData.id : undefined,
      carats: this.state.newCarat,
      size: this.state.newSize,
      pcs: this.state.newPcs,
      tenderlotids: this.state.tenderLotIds,
      date:
        Utility.ConvertLocalTimeToUtc(new Date()).slice(0, 11) +
        "00:00:00.000Z",
      expectedreceive:
        Utility.ConvertLocalTimeToUtc(this.state.newExpectedReceive).slice(
          0,
          11
        ) + "00:00:00.000Z",
      companyid: this.state.newCompany.value,
      tenderid: this.props.sourceData.tenderid,
      userid: Constants.loggedInUser.id,
      received: this.state.newReceived,
    };

    if (this.props.handleSave) {
      if (this.props.handleValidation) {
        if (this.props.handleValidation(data)) this.props.handleSave(data);
        else
          this.setState({
            showError: true,
          });
      } else this.props.handleSave(data);
    }
  };

  closeErrorDialog = () => {
    this.setState({
      showError: false,
    });
  };

  validateLotIntimationPresent = (lotIntimationEntered) => {
    if (!lotIntimationEntered || lotIntimationEntered.trim() === "") return;

    this.setState({
      validateLotIntimationPresentSpinner: true,
    });

    LotIntimationProxy.CheckLotIntimationAvailable(
      lotIntimationEntered,
      (response) => {
        //if we got response that means lotIntimation is present at backend
        if (response) {
          //LotIntimationName already present
          this.setState({
            validateLotIntimationPresentSpinner: false,
            showValidationMessage: true,
            lotIntimationAvailable: false,
          });
        } else {
          //LotIntimationName not available, so can be used
          this.setState({
            validateLotIntimationPresentSpinner: false,
            showValidationMessage: true,
            lotIntimationAvailable: true,
          });
        }
      }
    );
  };

  buttonDisable = () => {
    if (
      this.props.editOperation &&
      (this.state.caratValidationError.length !== 0 ||
        this.state.newCarat.length === 0)
    ) {
      return true;
    }

    if (!this.props.editOperation) {
      return (
        this.state.caratValidationError.length !== 0 ||
        this.state.newCarat.length === 0
      );
    }

    return false;
  };

  render() {
    return (
      <Box>
        <CommonSnackbar
          show={this.state.showError}
          message={
            <Box>
              Add lot Intimation validation Failed
              <br /> Please enter complete data
            </Box>
          }
          variant={"error"}
          autoHide={false}
          handleClose={this.closeErrorDialog}
          title="Validation Failure"
        />

        <Modal backdrop="static" show={this.props.Show} onHide={this.props.handleClose} enforceFocus={false}>
          <Modal.Header closeButton>
            <Modal.Title>
              <img
                src={logo}
                height="40pt"
                width="40pt"
                alt={Constants.COMPANY_SITE}
              />
              &nbsp;&nbsp;
              {this.props.editOperation || this.props.sourceData === undefined
                ? "Edit Lot Intimation"
                : "Add New Lot Intimation"}
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Box
              sx={{
                width: "100%",
                "& .css-2vawn2-MuiTypography-root": {
                  alignSelf: "center",
                },
              }}
            >
              <Box display={"flex"} gap="15px" mt={2}>
                {" "}
                <Typography sx={{ width: "25%" }}>
                  Expected Receive
                </Typography>
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <DatePicker
                    ampm={true}
                    renderInput={(props) => (
                      <TextField
                        fullWidth
                        size="small"
                        // style={{ width: "90%" }}
                        {...props}
                        inputProps={{ ...props.inputProps, readOnly: true }}
                      />
                    )}
                    error={false}
                    value={this.state.newExpectedReceive}
                    inputFormat="DD/MM/YYYY"
                    onChange={(newValue) => {
                      // Get the current time
                      const now = dayjs();

                      // Set startOfMonth to the first day of the selected month, but with the current system time
                      const newExpectedReceive = dayjs(newValue)
                        .hour(now.hour())
                        .minute(now.minute())
                        .second(now.second())
                        .millisecond(now.millisecond())
                        .toDate();

                      this.setState({ newExpectedReceive: newExpectedReceive });
                    }}
                  />
                </LocalizationProvider>
              </Box>
              <Box sx={{ display: "flex", alignItems: "center" }}>
                <Typography sx={{ width: "29%" }}>
                  Carats <sup style={{ color: "red" }}>*</sup>
                </Typography>
                <TextField
                  margin="normal"
                  vendor="small"
                  size="small"
                  fullWidth
                  type={"number"}
                  label="carats (required)"
                  placeholder="Enter Carats"
                  value={this.state.newCarat}
                  disabled={!this.state.editable}
                  onChange={(e) =>
                    this.setState({
                      newCarat: e.target.value,
                      caratValidationError: Utility.CheckisNumberPositive(
                        e.target.value
                      )
                        ? ""
                        : "Carat Should be a postive number",
                    })
                  }
                  helperText={this.state.caratValidationError}
                  error={this.state.caratValidationError.length > 0}
                />
              </Box>
              <Box sx={{ display: "flex", alignItems: "center" }}>
                <Typography sx={{ width: "29%" }}>
                  Size
                </Typography>
                <TextField
                  margin="normal"
                  vendor="small"
                  size="small"
                  fullWidth
                  label="size"
                  placeholder="Enter Size"
                  value={this.state.newSize}
                  disabled={!this.state.editable}
                  onChange={(e) =>
                    this.setState({
                      newSize: e.target.value,
                    })
                  }
                />
              </Box>
              <Box sx={{ display: "flex", alignItems: "center" }}>
                <Typography sx={{ width: "29%" }}>
                  PCS
                </Typography>
                <TextField
                  margin="normal"
                  vendor="small"
                  size="small"
                  fullWidth
                  type={"number"}
                  label="pcs"
                  placeholder="Enter pcs"
                  disabled={!this.state.editable}
                  value={this.state.newPcs}
                  onChange={(e) =>
                    this.setState({
                      newPcs: e.target.value,
                    })
                  }
                />
              </Box>
              <Box sx={{ display: "flex", mt: 2 }}>
                <Typography sx={{ width: "25%" }}>
                  Company
                </Typography>

                <Box sx={{ width: "75%", mr: "11px" }}>
                  <Select menuPlacement="auto"
                    blurInputOnSelect={false}
                    className="basic-single"
                    classNamePrefix="select"
                    getOptionLabel={(option) => option.label}
                    getOptionValue={(option) => option.value}
                    value={this.state.newCompany}
                    isSearchable={true}
                    name="Company"
                    menuPortalTarget={document.body}
                    styles={Constants.Styles}
                    options={this.state.companyOptions}
                    onChange={(selectedOption) =>
                      this.setState({
                        newCompany: selectedOption,
                      })
                    }
                  />
                </Box>
                {this.state.showCompanyLoadSpinner ? (
                  <CircularProgress size="1em" style={{ marginRight: '10px' }} />
                ) : (
                  <Tooltip title="Reload">
                    <RefreshOutlinedIcon
                      color="primary"
                      style={{ marginRight: '10px', cursor: "pointer", marginTop: "7px" }}
                      fontSize="medium"
                      onClick={() => this.getCompanyData()}
                    />
                  </Tooltip>
                )}
              </Box>
              <Box sx={{ display: "flex", alignItems: "center" }} mt={2}>
                <Typography sx={{ width: "23%" }}>Received</Typography>
                <Typography color={this.state.newReceived ? "#1976d2" : "red"}>
                  {this.state.newReceived ? "True" : "False"}
                </Typography>
              </Box>
            </Box>
          </Modal.Body>
          <Modal.Footer>
            <LoadingButton
              loading={this.props.loading}
              loadingPosition="start"
              startIcon={<SaveIcon />}
              variant="contained"
              onClick={() => this.handleSave()}
              disabled={this.buttonDisable()}
              sx={{ mr: 1 }}
            >
              Save
            </LoadingButton>
            <Button
              variant="contained"
              color="error"
              onClick={this.props.handleClose}
              disabled={this.props.loading}
            >
              Close
            </Button>
          </Modal.Footer>
        </Modal>
      </Box>
    );
  }
}
